module.exports = __webpack_public_path__ + "static/media/CTLI_3-111w.c26b9ea9.webp";